
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 14.5a1 1 0 10-2 0 1 1 0 002 0zm-4.012-.654a1 1 0 10-1.618-1.175 1 1 0 001.618 1.175zm7.42.222a1 1 0 10-1.175-1.618 1 1 0 001.175 1.618zM2.128 10.96a1 1 0 10-.62-1.903 1 1 0 00.62 1.903zm13.005-.642A1 1 0 1013.23 9.7a1 1 0 001.902.618zM2.769 6.3a1 1 0 10-1.902-.618A1 1 0 002.77 6.3zm11.722.642a1 1 0 10-.618-1.902 1 1 0 00.618 1.902zM4.767 3.55a1 1 0 10-1.175-1.618A1 1 0 004.767 3.55zm7.863-.22a1 1 0 10-1.618-1.176 1 1 0 001.618 1.175zM9 1.5a1 1 0 10-2 0 1 1 0 002 0zm.76 7.16a2.253 2.253 0 10-3.519 0l.002.003c.043.054.084.11.125.166l.064.085.443.583c.334.437.751.975 1.125 1.437.376-.463.794-1.002 1.129-1.44.18-.234.334-.438.443-.583.024-.03.047-.063.07-.094.038-.053.077-.106.117-.156zm.583.469l-.001.001a92.338 92.338 0 01-1.849 2.38.633.633 0 01-.986 0c-.805-.985-1.847-2.38-1.847-2.38l-.002-.002a3 3 0 114.686-.002h-.001l-.001.002h.002zM8 7.613a.373.373 0 100-.747.373.373 0 000 .747zm1.12-.373a1.12 1.12 0 11-2.24 0 1.12 1.12 0 012.24 0z","fill":"currentColor"}})])
          )
        }
      }
    